module.exports = __webpack_public_path__ + "static/media/SBPhotography_1-1267w.09581845.webp";